function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.9854 18.7982C10.9854 18.1677 11.4964 17.6566 12.1269 17.6566C12.7574 17.6566 13.2685 18.1677 13.2685 18.7982C13.2685 19.4287 12.7574 19.9397 12.1269 19.9397C11.4964 19.9397 10.9854 19.4287 10.9854 18.7982Z",
  fill: "#B70A0A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.1263 6.99927C12.5466 6.99927 12.8873 7.34008 12.8873 7.7605V15.3728C12.8873 15.7932 12.5466 16.134 12.1263 16.134C11.706 16.134 11.3652 15.7932 11.3652 15.3728V7.7605C11.3652 7.34008 11.706 6.99927 12.1263 6.99927Z",
  fill: "#B70A0A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.756 20.695C24.515 22.2134 23.4112 24 21.7139 24L2.28608 24C0.58884 24 -0.515048 22.2134 0.243982 20.695L9.9579 1.2624C10.7993 -0.420796 13.2007 -0.4208 14.0421 1.26239L23.756 20.695ZM21.7139 22.4775C22.2797 22.4775 22.6476 21.882 22.3946 21.3759L12.6807 1.94326C12.4002 1.3822 11.5998 1.3822 11.3193 1.94326L1.60538 21.3759C1.35237 21.882 1.72033 22.4775 2.28608 22.4775L21.7139 22.4775Z",
  fill: "#B70A0A"
});

const SvgWarning = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning.8b52f144.svg";
export { ForwardRef as ReactComponent };